export default __webpack_public_path__ + "static/media/thumbs-down.0a2c5feb.svg";